import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import NewBusinessAnalysisTable from './NewBusinessAnalysisTable';
import NewBusinessAnalysisTableHeader from './NewBusinessAnalysisTableHeader';
import PropTypes from 'prop-types';

const NewBusinessAnalysisWrapTable = ({
  filter,
  title,
  times,
  loadDataFunc,
  formatHeader,
  targetValue
}) => {
  const [frames, setFrames] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);

  useEffect(() => {
    loadFrameSummarys(filter);
  }, [filter]);

  const loadFrameSummarys = async filter => {
    setLoadingTable(true);
    let id = filter?.accountManager || 0;
    let year = filter?.year || new Date().getFullYear();
    if (id > 0) {
      await loadDataFunc(id, year)
        .then(res => {
          console.log(res);
          let parseData = parseToArray(res.data?.data);
          console.log(parseData);
          setFrames(parseData);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      console.log('invalid Id: ' + id);
    }
    setLoadingTable(false);
  };

  function parseToArray(data) {
    console.log(data);
    return Object.entries(data)
      .sort(([, a], [, b]) => a.customer.localeCompare(b.customer))
      .map(([id, details]) => ({
        id,
        customer: details.customer,
        data: details.data,
        fpw: details.fpw
      }));
  }
  return (
    <>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <NewBusinessAnalysisTableHeader title={title} />
            <Row style={{ padding: '10px' }}>
              <NewBusinessAnalysisTable
                times={times}
                data={frames}
                loading={loadingTable}
                formatHeader={formatHeader}
                targetValue={targetValue}
              />
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
};

NewBusinessAnalysisWrapTable.propTypes = {
  filter: PropTypes.func,
  title: PropTypes.string,
  times: PropTypes.array,
  loadDataFunc: PropTypes.func,
  formatHeader: PropTypes.func,
  targetValue: PropTypes.number
};

export default NewBusinessAnalysisWrapTable;
